export default __webpack_public_path__ + "static/media/Dpid.7f64d6e2.png";